import BaseProxy from './Proxy';

export default class LangProxy extends BaseProxy {
  constructor(parameters = {}) {
    super('api/lang', parameters);
  }

  set(lang) {
    return this.submit('post', `${this.endpoint}/${lang}`);
  }
}
